import { abilityArtName } from '@chaos/protocol';

/**
 * Where an ability's medallion lives.
 *
 * ONE MAPPING, TWO BARS. The touch cluster and the desktop ability row are
 * different components with different layouts, and they were never going to
 * stay in step if each computed its own filename — the icons shipped to touch
 * only, and desktop kept the text glyphs for a full release without anyone
 * noticing they were meant to match.
 *
 * The naming rule itself moved to `@chaos/protocol`, because the same drift
 * then happened one level up: the shell's character select draws these too, in
 * another app, and grew its own copy. Two apps drift for the reason two
 * components do and slower, because nothing builds them together. The protocol
 * owns `character.id` and `ability.id`, so it owns the name they compose into.
 *
 * What stays here is what the protocol has no opinion about: where this client
 * serves the files from.
 */

const ART_BASE = '/abilities';

/**
 * The medallion URL for one slot, or null when there is nothing to draw.
 *
 * `def` is the character's roster row. `action` is the control's slot —
 * `dash` and `jump` have no AbilityDef of their own, which the shared map in
 * the protocol handles.
 */
export function abilityArtUrl(def, action) {
  if (!def) return null;
  const name = abilityArtName(def.id, action);
  return name === null ? null : `${ART_BASE}/${name}.webp`;
}
